// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"80738d45489f7f5f6247","655":"fff5c516eaae2ab7f8f6"}[chunkId] + ".js";
};